import IntelligenceDashboardPage from './IntelligenceDashboardPage';

/**
 * The home page after sign-in. Renders the Intelligence Dashboard
 * directly so the first thing a lawyer sees is the all-in-one
 * defendant profile + recommended-strategy view — the whole product
 * pitch.
 *
 * Old document-stats dashboard moved aside; if it's needed later we
 * can resurface as a "/app/documents" overview.
 */
export default function DashboardPage() {
  return <IntelligenceDashboardPage />;
}
